import { useEffect, useState } from "react";
// Custom hook to detect if the device is small screen
const useIsSmallScreen = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const checkSmallScreen = () => {
      if (window.innerWidth <= 768) {
        setIsSmallScreen(true);
      } else return setIsSmallScreen(false);
    };
    checkSmallScreen();
    window.addEventListener("resize", checkSmallScreen);
    return () => window.removeEventListener("resize", checkSmallScreen);
  }, []);
  return isSmallScreen;
};

export default useIsSmallScreen;
